<template>
    <div style="min-height:90h; max-height:90vh">
        <!-- <vue-markdown :source="content"></vue-markdown> -->
        <div class="container">
            <div class="row">
                <div class="col-1"></div>
                <div class="col-1" style="padding: 5px;">
                    <a href="/function">
                        <img src="../../../../assets//Logo//Logo2.png" alt="" width="120px">
                    </a>
                </div>
                <div class="col-8"></div>
                <div class="col">
                    <div style="max-height:10vh; min-height:10vh; padding:13px">
                    <el-button @click="goBack" type="success" plain>取消</el-button>
                    <el-button @click="outputENter" type="success">确定</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div style="min-height:6vh; max-height: 6vh;">
            <el-input
            maxlength="100"
            show-word-limit
            style="height: 10vh;"
            placeholder="请输入标题"
            v-model="title"
            clearable>
            </el-input>
        </div>
        <div class="home">
            <mavon-editor :codeStyle="codeStyle" :toolbars="toolbars" style="min-height:84vh; max-height: 84vh;" :tabSize="tabSize" v-model="content" :ishljs="true" ref="md" @change="change"/>
        </div>
    </div>
</template>

<script>
    // import VueMarkdown from 'vue-markdown'
    import $ from 'jquery'
    export default {
        name:'MakeNotes',
        components: {
            // VueMarkdown,
        },
        // props:["allContent"],
        data() {
            return {
                title:'',
                content: "[//]: # (推荐题解模板，请替换blablabla等内容 ^^)\n\n### 题目描述\n\nblablabla\n\n#### 样例\n\n```\nblablabla\n```\n\n\n----------\n\n### 算法1\n\n##### (暴力枚举)  $O(n^2)$\n\nblablabla\n\n#### 时间复杂度\n\n#### 参考文献\n\n#### C++ 代码\n\n```\nblablabla\n```\n\n----------\n\n",
                tabSize:4,
                page_article:undefined,
                html_content:undefined,
                md_content:undefined,
                toolbars: {
                    bold: true, // 粗体
                    italic: true, // 斜体
                    header: true, // 标题
                    underline: true, // 下划线
                    strikethrough: true, // 中划线
                    mark: true, // 标记
                    superscript: true, // 上角标
                    subscript: true, // 下角标
                    quote: true, // 引用
                    ol: true, // 有序列表
                    ul: true, // 无序列表
                    link: true, // 链接
                    imagelink: true, // 图片链接
                    code: true, // code
                    table: true, // 表格
                    fullscreen: true, // 全屏编辑
                    readmodel: true, // 沉浸式阅读
                    htmlcode: true, // 展示html源码
                    help: true, // 帮助
                    undo: true, // 上一步
                    redo: true, // 下一步
                    trash: true, // 清空
                    save: true, // 保存（触发events中的save事件）
                    navigation: true, // 导航目录
                    alignleft: true, // 左对齐
                    aligncenter: true, // 居中
                    alignright: true, // 右对齐
                    subfield: true, // 单双栏模式
                    preview: true // 预览
                },
                codeStyle:'monokai-sublime',//主题
                test_html:undefined,
            }
        },
        methods:{
            goBack() {
                this.$router.back(); // 返回上一页
            },
            outputENter(){ //
                const vue = this
                const store = this.$store
                const route = this.$route
                const router = this.$router

                console.log(JSON.stringify(this.test_html))   //就用这个存数据库  然后进行回显即可
                
                $.ajax({
                    url: 'https://app6132.acapp.acwing.com.cn/api/notes/add/',
                    type: "post",
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        title: vue.title,
                        pbid: route.params.id,
                        markdown: vue.content,
                        content: vue.test_html,
                    },
                    success(resp) {
                        if (resp.error_message === 'success') {
                            console.log("id == > ", resp.id)
                            router.push({
                                name:'ShowNotes',
                                params: {
                                    id: resp.id
                                }
                            })
                        } else {
                            console.log("添加题解失败了，原因是 ==> ", resp.error_message)
                        }
                    },
                    error(resp) {
                        console.log("添加题解彻底失败了，原因是 ==> ", resp)
                    }
                })
            },
            change(value, render){
                // render 为 markdown 解析后的结果
                // console.log(render)
                this.test_html = render;
            },
        },
    }
</script>

<style scoped>
.hljs{
  font-size: 15px;
}
.info{
  border-radius: 10px;
  line-height: 20px;
  padding: 10px;
  margin: 10px;
  background-color: #ffffff;
}
</style>